var AjaxCalls = {

    participants: function(){
        var form = $("#inscriptionForm");
        form.on('submit', function(e){
            e.preventDefault();

            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'send_mail',
                    data: $(this).serialize(),
                },
                success: function(response) {
                    var response = JSON.parse(response);
                    console.log(response);

                    if (response.success) {
                        form[0].reset();
                        $('.form-core').fadeOut(function(){
                            $('.form-core').hide();

                            $("html,body").animate({scrollTop: 0}, "slow");
                        });
                    }

                    $('.response').prepend('<div class="message">'+response.message+'</div>');
                    $('#inscriptionForm').find('.title').html("Merci !");
                },
                error: function() {
                    console.log('Erreur lors de l\'envoi');
                }
            });
        });
    }
}

$(document).ready(function(){
	if($("#inscriptionForm").length){
		AjaxCalls.participants();
	}
});